import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const dashboard: AppRouteModule = {
  path: '/dashboard',
  name: 'Dashboard',
  component: LAYOUT,
  redirect: '/dashboard/home',
  meta: {
    orderNo: 10,
    icon: 'ion:grid-outline',
    title: t('routes.dashboard.dashboard'),
  },
  children: [
    {
      path: 'home',
      name: 'Home',
      component: () => import('/@/views/dashboard/home/index.vue'),
      meta: {
        // affix: true,
        title: t('routes.dashboard.home'),
      },
    },
    {
      path: 'news-latest',
      name: 'DashboardNewsLatest',
      component: () => import('/@/views/dashboard/home/NewsGridPage.vue'),
      meta: {
        title: '最新消息',
        hideMenu: true,
        currentActiveMenu: '/dashboard/home',
        newsTab: 'latest',
      },
    },
    {
      path: 'news-industry',
      name: 'DashboardNewsIndustry',
      component: () => import('/@/views/dashboard/home/NewsGridPage.vue'),
      meta: {
        title: '行业动态',
        hideMenu: true,
        currentActiveMenu: '/dashboard/home',
        newsTab: 'industry',
      },
    },
    {
      path: 'news-pharma',
      name: 'DashboardNewsPharma',
      component: () => import('/@/views/dashboard/home/NewsGridPage.vue'),
      meta: {
        title: '医药情报',
        hideMenu: true,
        currentActiveMenu: '/dashboard/home',
        newsTab: 'pharma',
      },
    },
    {
      path: 'news-product',
      name: 'DashboardNewsProduct',
      component: () => import('/@/views/dashboard/home/NewsGridPage.vue'),
      meta: {
        title: '产品动态',
        hideMenu: true,
        currentActiveMenu: '/dashboard/home',
        newsTab: 'product',
      },
    },
    {
      path: 'news-list',
      name: 'DashboardNewsList',
      component: () => import('/@/views/dashboard/home/NewsListPage.vue'),
      meta: {
        title: '资讯列表',
        hideMenu: true,
        currentActiveMenu: '/dashboard/home',
      },
    },
    {
      path: 'analysis',
      name: 'Analysis',
      component: () => import('/@/views/dashboard/Analysis/index.vue'),
      meta: {
        // affix: true,
        title: t('routes.dashboard.analysis'),
      },
    },
    {
      path: 'workbench',
      name: 'Workbench',
      component: () => import('/@/views/dashboard/workbench/index.vue'),
      meta: {
        title: t('routes.dashboard.workbench'),
      },
    },
  ],
};

export default dashboard;
